import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "ShopTheSetLazy" */ './ShopTheSet'), {
    fallback: null,
});
